import { render } from "./callFollowUpFormV2.vue?vue&type=template&id=6354a830&scoped=true"
import script from "./callFollowUpFormV2.vue?vue&type=script&lang=js"
export * from "./callFollowUpFormV2.vue?vue&type=script&lang=js"

import "./callFollowUpFormV2.vue?vue&type=style&index=0&id=6354a830&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6354a830"]])

export default __exports__